var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[_vm.$style.classification] = true, _obj[_vm.$style[("grade" + (_vm.value && _vm.value.classification))]] = !_vm.hasError, _obj[_vm.$style.error] = _vm.hasError, _obj ),attrs:{"title":_vm.trace}},[(_vm.hasError)?_c('span',[_vm._v("\n    -\n  ")]):_c('span',[_vm._v(_vm._s(_vm.value.classification > 0 ? _vm.value.classification : ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }